i18n.messages = {};

export default function i18n (key = '', options = {}) {
  if ('count' in options && options.count !== 1) {
    key += '_plural';
  }

  const text = getText(key);

  if (!text) {
    return `???${key}???`;
  }

  return Object.keys(options).reduce(function (text, o) {
    return text.replace(new RegExp(`{{${o}}}`, 'g'), options[o]);
  }, text);
}

function getText (key) {
  const colonIndex = key.indexOf(':');
  if (colonIndex !== -1) {
    const ns = key.substr(0, colonIndex);
    const localKey = key.substr(colonIndex + 1);
    return i18n.namespaces[ns] && i18n.namespaces[ns][localKey];
  } else {
    return i18n.messages[key];
  }
}

i18n.namespaces = {};

export function defineNamespace (ns, messages) {
  i18n.namespaces[ns] = Object.assign({}, i18n.namespaces[ns], messages);
}
